import request from '@/utils/request'
import requestNoDialog from '@/utils/requestNoDialog'
import {getUserInfo, getUserId} from '@/utils/storage'

export async function getWechatInfoByOpenidAndUnionId(params) {
    return request({
        url: '/wx/wechat/xcx/getWechatInfoByOpenidAndUnionId', method: 'get', params
    })

}

export async function getUserInfoByUserId(params) {
    return request({
        url: '/wx/user/queryById', method: 'get', params
    })
}

// //根据搜索条件查询公司信息
// export async function getCompanyInfoByAliyunInterface(params) {
//     return request({ url: '/wx/company/getCompanyInfoByAliyunInterface', method: 'get', params
//     })
// }
// //获取首页的通知公告
// export async function getTopPolicy(params) {
//     return request({
//         url: '/app/notify/search', method: 'post', params
//     })
// }
// //获取首页的轮播图
// export async function getLatestRecord(params) {
//     return request({
//         url: '/wx/searchRecord/getLatestRecord', method: 'get', params
//     })
// }

// //获取匹配条件的领域信息
// export async function getQueryAll() {
//     return request({ url: '/wx/tag/queryAll', method: 'get' })
// }
export async function queryBySpec(params) {
    return request({url: '/wx/company/queryBySpec', method: 'get', params})
}

// //获取匹配接口
// export async function getPolicyByTags(_params) {
//     let params = {
//         ..._params,
//         // userId: getUserId() ? getUserId(): ''
//     }
//     return request({ url: '/wx/policy/getPolicyByTags', method: 'post', data:params })
// }
// //获取服务商
// export async function getServiceProviderList(params) {
//     return request({ url: '/app/provider/search', method: 'post', params })
// }
// //获取服务商
// export async function getServiceQueryById(params) {
//     return request({ url: '/app/provider/info', method: 'post', params })
// }
//获取详情
export async function queryById(params) {
    // return request({ url: '/wx/policy/queryById', method: 'get', params })
    return request({url: '/app/notify/info', method: 'post', params})
}

// //收藏
// export async function addFavorite(params) {
//     return request({ url: '/app/favorite/follow', method: 'post', data:params })
// }
// //取消收藏
// export async function cancelFavorite(params) {
//     return request({ url: '/app/favorite/unfollow', method: 'post', params })
// }
// // 查询收藏
// export async function queryFavorite(params) {
//     return request({ url: '/app/favorite/search', method: 'post', params })
// }

//查询记录
export async function SearchRecordQueryBySpec(params) {
    return request({url: '/wx/searchRecord/queryBySpec', method: 'get', params})
}

//政策
export async function getPolicyBySpec(params) {
    return request({url: '/wx/policy/getPolicyBySpec', method: 'get', params})
}

// //订单列表
// export async function getOrdersBySpec(params) {
//     // let params = {
//     //     ..._params,
//     //     // companyUserId: getUserInfo() ? JSON.parse(getUserInfo()).id : '',
//     //     userId: getUserId() ? getUserId() : ''
//     // }
//     return request({ url: '/wx/order/getOrdersBySpec', method: 'get', params })
// }
// //收藏列表
// export async function queryFavoritesByCompanyUserId(params) {
//     // let params = {
//     //     ..._params,
//     //     // companyUserId: getUserInfo() ? JSON.parse(getUserInfo()).id : ''
//     //     userId: getUserId() ? getUserId() : ''
//     // }
//     return request({ url: '/wx/favorite/queryFavoritesByCompanyUserId', method: 'get', params })
// }

// //事项列表
// export async function queryEvaluationByUserId(params) {
//     // let params = {
//     //     ..._params,
//     //     // companyUserId: getUserInfo() ? JSON.parse(getUserInfo()).id : ''
//     //     userId: getUserId() ? getUserId() : ''
//     // }
//     return request({ url: '/wx/matters/queryEvaluationByUserId', method: 'get', params })
// }
// export async function getEvaluationDetail(params) {

//     return request({ url: '/wx/matters/queryById', method: 'get', params })
// }

// //增加评论
// export async function addEvaluation(params) {
//     return request({ url: '/wx/matters/addEvaluation', method: 'post', data: params })
// }
// //修改评价
// export async function updateEvaluation(params) {
//     return request({ url: '/wx/matters/updateEvaluation', method: 'post', data: params })
// }

export async function getVip(params) {
    return request({url: '/wx/vipOrder/queryVipFlagByUserId', method: 'get', params})
}

// //获取订单详情
// export async function queryOrderById(params) {
//     return request({ url: '/wx/order/queryById', method: 'get', params })
// }

//根据用户id查询企业信息
export async function companyQueryByUserId(params) {
    return request({url: '/wx/company/queryByUserId', method: 'get', params})
}

// //获取政策申报/政策文件/通知公告的发文部门列表
// export async function dispatchDepartmentGetAll(params) {
//     return request({ url: '/wx/dispatchDepartment/getAll', method: 'get', params })
// }

//获取服务商详情的轮播图
export async function getImgUrl(params) {
    return request({url: `/wx/serviceProvider/getImgUrl/${params.id}`, method: 'get', params})
}

export async function queryUserById(params) {
    // return request({ url: `/wx/user/queryUserById`, method: 'get', params })
    return requestNoDialog({url: `/app/user/info`, method: 'post', params})
}

export async function getSNUser(params) {
    return request({url: `/wx/salesman/getSNUser`, method: 'get', params})
}


export async function savePhoneAndCompanyName(params) {
    return request({url: '/app/order/create', method: 'post', params})
}

//确认企业信息，根据手机号获取验证码
export async function getCode(params) {
    return request({url: '/app/sms/send', method: 'post', params})
}


//获取政策申报详情
export async function queryDeclareInfo(params) {
    return request({url: '/app/article/info_v3', method: 'post', params})
}

//获取政策申报详情v3
export async function queryDeclareInfov3(params) {
    return request({url: '/app/article/info_v3', method: 'post', params})
}

//获取政策申报详情企业自身修改v3
export async function queryDeclareInfov4(params) {
    return request({url: '/app/company/update_tag', method: 'post', params})
}

//获取政策申报详情v3
export async function queryDeclareInfov3change(params) {
    return request({url: 'app/company/update_extend_data', method: 'post', data: params})
}

//获取政策文件详情
export async function queryPolicyInfo(params) {
    return request({url: '/app/policy/info', method: 'post', params})
}

//获取通知公告详情
export async function queryNotifyInfo(params) {
    return request({url: '/app/notify/info', method: 'post', params})
}

//政策--政策申报、政策文件、通知公告
export async function queryArticleSearch(params) {
    return request({url: '/app/article/search', method: 'post', params})
}

//获取政策申报/政策文件/通知公告的发文部门列表
export async function dispatchDepartmentGetAll(params) {
    return request({url: '/app/article/getdispatchs', method: 'post', params})
}

//获取服务商
export async function getServiceProviderList(params) {
    return request({url: '/app/provider/search', method: 'post', params})
}

/****首页****/
//获取首页的通知公告
export async function getTopPolicy(params) {
    return request({
        url: '/app/notify/search', method: 'post', params
    })
}

//获取首页的轮播图
export async function getLatestRecord(params) {
    return request({
        url: '/app/search_record/search', method: 'post', params
    })
}

/****首页****/
/****匹配****/
//根据搜索条件查询公司信息
export async function getCompanyLists(params) {
    return request({url: '/app/company/search', method: 'post', params})
}

//获取匹配条件的领域信息
export async function getQueryAll() {
    return request({url: '/app/tag/search', method: 'post'})
}

//获取匹配接口
export async function getPolicyByTags(params) {
    return request({url: '/app/declare/match', method: 'post', data: params})
}

//获取匹配接口
export async function getPolicyByTagsV2(params) {
    return request({url: '/app/declare/match_v2', method: 'post', data: params})
}

export async function getPolicyByTagsV3child(params) {
    return request({
        url: '/app/declare/match_v3_child', method: 'post', data: params
    })
}

export async function getPolicyByTagsV3(params) {
    return request({
        url: '/app/declare/match_v3', method: 'post', data: params
    })
}

//获取匹配--模糊搜索
//传参name
export async function getCompanySearchInfoV2(params) {
    return request({url: '/app/company/search_info', method: 'post', data: params})
}

//获取匹配公司的信息
//无传参
export async function getCompanyInfoV2(params) {
    return request({url: '/app/company/info', method: 'post', data: params})
}

/****匹配****/
//收藏
export async function addFavorite(params) {
    return request({url: '/app/favorite/follow', method: 'post', data: params})
}

//取消收藏
export async function cancelFavorite(params) {
    return request({url: '/app/favorite/unfollow', method: 'post', params})
}

//查询收藏
export async function queryFavorite(params) {
    return request({url: '/app/favorite/search', method: 'post', params})
}

//收藏列表
export async function queryFavoritesByCompanyUserId(params) {
    return request({url: '/app/favorite/search', method: 'post', params})
}

//收藏列表
export async function queryFavoritesByCompanyUserIdv3(params) {
    return request({url: '/app/favorite/search_v3', method: 'post', params})
}

//事项列表
export async function queryEvaluationByUserId(params) {
    return request({url: '/app/matters/search', method: 'post', params})
}

//评价详情
export async function getEvaluationDetail(params) {
    return request({url: '/app/matters/info', method: 'post', params})
}

//增加评论
export async function addEvaluation(params) {
    return request({url: '/app/matters/create', method: 'post', data: params})
}

//修改评价
export async function updateEvaluation(params) {
    return request({url: '/app/matters/edit', method: 'post', data: params})
}

//订单列表
export async function getOrdersBySpec(params) {
    return request({url: '/app/order/search', method: 'post', params})
}

//获取订单详情
export async function queryOrderById(params) {
    return request({url: '/app/order/info', method: 'post', params})
}

//获取服务商
export async function getServiceQueryById(params) {
    return request({url: '/app/provider/info', method: 'post', params})
}

//获取服务商
export async function vipOrderCreate(params) {
    return request({url: '/app/vip_order/create', method: 'post', params})
}

//支付/立即续费
export async function vipOrderCreateV3(params) {
    return request({url: '/app/vip_order/create_v3', method: 'post', params})
}

/************政策狩猎精灵***********/
//绑定企业信息
export async function saveDisk(params) {
    return request({url: '/app/upan/create', method: 'post', params})
}

/************科服券***********/
//我的卡券的列表
export async function couponSearch(params) {
    return request({url: '/app/coupon/search', method: 'post', data: params})
}

export async function companyEdit(params) {
    return request({url: '/app/company/edit', method: 'post', data: params})
}

export async function upload(params) {
    return request({url: '/app/company/upload', method: 'post', data: params})
}

/************科服券***********/
/**
 * 获取政企超链接的用户信息（政企超，暂时/zqclj/app/user/info改为/app/user/info）
 * status == 0 没有注册
 * questions.status == 0 没有调研
 */
export async function getUserInfoZqcli(params) {
    return requestNoDialog({url: '/app/user/info', method: 'post', data: params})
}

//立项查询
export async function lxcxLists(params) {
    return request({url: '/app/lxcx/lists', method: 'get', params})
}

/**企业匹配
 *用户的userInfo信息中certification_flag为0=》没有进行企业认证,1=》已进行企业认证
 */
export async function companyCertificationV2(params) {
    return request({url: '/app/company/company_certification', method: 'get', params})
}

//
export async function getArticleKvV3(params) {
    return request({url: '/app/article/kv', method: 'post', data: params})
}

//详情页获取相似文件
export async function getArticleSimilarV3(params) {
    return request({url: '/app/article/similar', method: 'post', data: params})
}

//获取首页政策情报数据
export async function getArticleIntelligenceV3(params) {
    return request({url: '/app/declare/intelligence', method: 'get', params})
}

//获取信息中心的接口
export async function getInformation(params) {
    return request({url: 'app/article/search_v3', method: 'post', params})
}

//获取首页的接口
export async function getInformationv3(params) {
    return request({url: 'app/declare/match_v3', method: 'post', params})
}

//收藏
export async function addFavoritev3(params) {
    return request({url: '/app/favorite/follow_v3', method: 'post', data: params})
}

//取消收藏
export async function cancelFavoritev3(params) {
    return request({url: '/app/favorite/unfollow_v3', method: 'post', params})
}

//首页v3
export async function queryUserByIdv3(params) {
    // return request({ url: `/wx/user/queryUserById`, method: 'get', params })
    return request({url: `/app/user/info`, method: 'post', params})
}

//获取政策申报/政策文件/通知公告的发文部门列表
export async function dispatchDepartmentGetAllv3(params) {
    return request({url: '/app/article/match_v3', method: 'post', params})
}

//获取政策申报/政策文件/通知公告的发文部门列表
export async function getDispatchv3(params) {
    return request({url: 'app/article/getDispatch_v3', method: 'post', params})
}

//非认证用户接口申报匹配
export async function noVip(params) {
    return request({url: 'app/article/firstArticle', method: 'post', params})
}

//获取匹配结果，展示在页面
export async function companyInfoV3(params) {
    return request({url: 'app/company/info_v3', method: 'get', params})
}

//根据路由上的channels_id获取对应的数据（首页的背景，logo，文字）
export async function channelsUser(params) {
    return request({url: 'app/user/channels_user', method: 'get', params})
}

//全国筛选接口
export async function getDispatchlevel(params) {
    return request({url: 'app/article/getDispatch_level_v3', method: 'get', params})
}

//全国筛选接口
export async function getWxUserInfo(params) {
    return request({url: 'app/wechath5/userInfo', method: 'get', params})
}

//ai聊天
export async function aiChat(params) {
    return request({url: 'app/ai/chat', method: 'post', params})
}

//ai企业认证
export async function aiCompanyCertification(params) {
    return request({url: '/app/ai/company_certification', method: 'post', params})
}
